import pickBy from 'lodash/pickBy';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_WEBMASTER_PROFILE__REQUEST,
  ACTION_LOAD_WEBMASTER_PROFILE__SUCCESS,
  ACTION_LOAD_WEBMASTER_PROFILE__FAIL,

  ACTION_EDIT_WEBMASTER_PROFILE__REQUEST,
  ACTION_EDIT_WEBMASTER_PROFILE__SUCCESS,
  ACTION_EDIT_WEBMASTER_PROFILE__FAIL,
} from '../actionTypes';


const actionLoadWebmasterProfileSuccess = result => ({
  type: ACTION_LOAD_WEBMASTER_PROFILE__SUCCESS,
  payload: { result },
});

const actionLoadWebmasterProfileFail = error => ({
  type: ACTION_LOAD_WEBMASTER_PROFILE__FAIL,
  payload: { error },
});

export const actionLoadWebmasterProfileRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_WEBMASTER_PROFILE__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/webmaster/profile'
    ).then(
      result => {
        dispatch(actionLoadWebmasterProfileSuccess(result));
      },
      error => {
        dispatch(actionLoadWebmasterProfileFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionEditWebmasterProfileSuccess = result => ({
  type: ACTION_EDIT_WEBMASTER_PROFILE__SUCCESS,
  payload: { result },
});

const actionEditWebmasterProfileFail = error => ({
  type: ACTION_EDIT_WEBMASTER_PROFILE__FAIL,
  payload: { error },
});

export const actionEditWebmasterProfileRequest = profileFields => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_EDIT_WEBMASTER_PROFILE__REQUEST,
      payload: profileFields,
    });

    return apiClientHelper.put(
      '/rest/webmaster/webmaster',
      {
        data: pickBy(
          profileFields,
          value => value && value !== ''
        ),
      }
    ).then(
      result => {
        dispatch(actionEditWebmasterProfileSuccess(result));
      },
      error => {
        dispatch(actionEditWebmasterProfileFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
